import React from 'react';
import Image from 'frontastic/lib/image';
import Button from 'components/commercetools-ui/atoms/button';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import Markdown from 'components/commercetools-ui/organisms/markdown';
import { Tiempos } from 'fonts';

const SectionWithImageAndText = (props: any) => {
    const { content } = props;
    const imageDescription = content.description;
    const descriptionArray: any[] = [];
    descriptionArray?.push(imageDescription);

    return (
        <div className={`relative left-full w-screen -translate-x-full lg:grid lg:grid-cols-12 ${content.additional_css ?? ''}`}>
            <div id="advice-section" className={`flex items-center  lg:col-span-12 lg:px-0 
                ${content?.desktop_image_alignment === 'Left' ? 'md:flex-row' : 'lg:flex-row-reverse'} 
                ${content?.mobile_image_alignment === 'Top' ? 'flex-col' : 'flex-col'}`} >
                <div className="middleresolution:h-[37rem]  relative h-[20rem] w-full md:h-[46rem] lg:flex-1  lg:flex-grow xl:h-[32rem] 2xl:h-[45rem] ">
                    {content?.image?.url && (
                        <Image
                            priority
                            loading="eager"
                            src={content?.image?.url}
                            alt={content?.image?.description}
                            fill
                            style={{ objectFit: 'cover' }}
                        />
                    )}
                </div>
                <div className="flex-1 flex-grow lg:px-48 2xl:px-144 pb-48">
                    <div className={`relative pb-10 text-32 pt-10 font-medium leading-10 ${Tiempos.className}`}>
                        <h1 style={{ textAlign: 'center', fontSize: '40px' }}>{content.title}</h1>
                    </div>
                    <div>
                        <div className="image-container text-center px-24 text-16 md:text-18 xl:text-16 font-normal leading-6  text-[#333] lg:leading-8 2xl:text-20 [&amp;>div>img]:mb-10">
                            <Markdown markdown={content.description} className="text-center"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SectionWithImageAndText;